<template>
  <div class="welcome-section" v-show="show">
    <div class="welcome-content">
      <div class="welcome-header">
        <p class="welcome-title">Bienvenido al sistema AlliKamay</p>
      </div>
      <div class="welcome-body">
        <p>
          Aquí tienes algunos pasos para comenzar:
        </p>
        <ul class="steps-list">
          <li>
            <router-link to="/guias"
              ><strong
                >Revisa los tutoriales disponibles en la sección de
                ayuda.</strong
              ></router-link
            >
            Explora los tutoriales en nuestra sección de ayuda para aprender más
            sobre cómo usar el sistema.
          </li>
          <li v-if="p_idPerfil != 21">
            <router-link :to="`/personaform/${p_idPersona}`"
              ><strong>Configura tu información personal.</strong></router-link
            >
            Edita tu información personal para que podamos ofrecerte un servicio
            más personalizado.
          </li>
        </ul>
      </div>
      <div class="welcome-footer">
        <button type="button" class="btn btn-primary" @click="closePopup">
          Entendido
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Welcome",
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      p_idPersona: 0,
      p_idUsuario: 0,
      p_idPerfil: 0,
    };
  },
  mounted() {
    this.p_idPersona = window.sessionStorage.getItem("idPersona");
    this.p_idUsuario = window.sessionStorage.getItem("idUsuario");
    this.p_idPerfil  = window.sessionStorage.getItem("idPerfil");
  },
  methods: {
    closePopup() {
      this.$emit("update:show", false);
    },
  },
};
</script>

<style scoped>
.welcome-section {
  padding: 10px; /* Reduced padding */
  background-color: #f7f7f7;
  border-radius: 8px;
  border: 1px solid #ddd;
  margin-top: 10px; /* Reduced margin */
}

.welcome-content {
  padding: 10px; /* Reduced padding */
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.welcome-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px; /* Reduced margin */
}

.welcome-title {
  margin: 0;
  font-size: 20px; /* Smaller font size */
}

.welcome-body {
  margin-bottom: 10px; /* Reduced margin */
  font-size: 14px; /* Smaller font size */
}

.steps-list {
  padding-left: 20px;
  margin: 0; /* Reduced margin */
}

.welcome-footer {
  text-align: right;
}

.btn-close {
  cursor: pointer;
  border: none;
  background: blue;
  font-size: 14px; /* Slightly smaller close button */
}

button.btn {
  padding: 4px 12px; /* Smaller button padding */
  font-size: 14px; /* Smaller button font size */
}
</style>
